<template>
  <van-popup class="popup-adress" v-model="show" position="bottom" :style="{ height: '40%' }" @close="closePopup">
    <dr-row class="address-title" justifyContent="space-between" alignItems="center">
      <div>地址选择</div>
      <van-icon name="static/imgs/delete_icon.png" size="16" @click="closePopup" />
    </dr-row>
    <dr-row class="address-selet" justifyContent="flex-start" alignItems="center" flexFlow="nowrap">
      <div class="margin-right22" @click="clickAddress(1)">
        <span v-if="province" :style="{color:level == 1 ?'#0071ee':''}">{{ province }}</span>
        <span v-else style="color:#999999">请选择</span>
      </div>
      <div v-if="province" class="margin-right22" @click="clickAddress(2)">
        <span v-if="city" :style="{color:level == 2 ?'#0071ee':''}">{{ city }}</span>
        <span v-else style="color:#999999">市</span>
      </div>
      <div v-if="city" class="margin-right22" @click="clickAddress(3)">
        <span v-if="county" :style="{color:level == 3 ?'#0071ee':''}">{{ county }}</span>
        <span v-else style="color:#999999">区/县</span>
      </div>
    </dr-row>
    <div class="address-box address-box1" v-show="level == 1">
      <dr-row class="address-item" v-for="(item, index) in list1" :key="index" justifyContent="flex-start"
        alignItems="center" @click="selectAddresss(item, index)">
        <span v-if="activeIndex1 != null">
          <van-icon v-if="activeIndex1 == item.id" name="static/imgs/selet_item.png" class="address-icon-selet" />
          <div v-else class="address-icon-selet"></div>
        </span>
        <div class="text-size">{{ item.name }}</div>
      </dr-row>
    </div>
    <div class="address-box address-box2" v-show="level == 2">
      <dr-row class="address-item" v-for="(item, index) in list2" :key="index" justifyContent="flex-start"
        alignItems="center" @click="selectAddresss(item, index)">
        <span v-if="activeIndex2 != null">
          <van-icon v-if="activeIndex2 == item.id" name="static/imgs/selet_item.png" class="address-icon-selet" />
          <div v-else class="address-icon-selet"></div>
        </span>
        <div class="text-size">{{ item.name }}</div>
      </dr-row>
    </div>
    <div class="address-box address-box3" v-show="level == 3">
      <dr-row class="address-item" v-for="(item, index) in list3" :key="index" justifyContent="flex-start"
        alignItems="center" @click="selectAddresss(item, index)">
        <span v-if="activeIndex3 != null">
          <van-icon v-if="activeIndex3 == item.id" name="static/imgs/selet_item.png" class="address-icon-selet" />
          <div v-else class="address-icon-selet"></div>
        </span>
        <div class="text-size">{{ item.name }}</div>
      </dr-row>
    </div>
  </van-popup>
</template>

<script>
import { areaTree } from '@/request/home.js'
export default {
  props: {
    showAdress: {
      type: Boolean,
      default: false
    },
    defaultAddress: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    showAdress: {
      handler (val) {
        this.show = val
        if (this.show) {
          this.$nextTick(()=>{
            if (this.level == 1) {
              this.scrollCss('.address-box1')
              if (this.list1.length == 0) {
                this.getData()
              }
            } else if (this.level == 2) {
              this.scrollCss('.address-box2')
              if (this.list2.length == 0) {
                this.getData()
              }
            } else if (this.level == 3) {
              this.scrollCss('.address-box3')
              if (this.list3.length == 0) {
                this.getData()
              }
            }
          })
        }
      },
      immediate: true
    },
    defaultAddress: {
      handler (val) {
        if (val.length) {
          this.province = val[0].name
          this.city = val[1].name
          this.county = val[2].name
        }
      },
      immediate: true
    },
    level:{
      handler (val) {
        this.$nextTick(()=>{
          if (val == 1) {
            this.scrollCss('.address-box1')
          } else if (val == 2) {
            this.scrollCss('.address-box2')
          } else {
            this.scrollCss('.address-box3')
          }
        })
      },
      immediate: false
    }
  },
  data () {
    return {
      show: false,
      seletAddress: ["", "", ""],

      province: "",
      city: "",
      county: "",

      level: 1,
      activeIndex1: null,
      activeIndex2: null,
      activeIndex3: null,
      list1: [],
      list2: [],
      list3: [],
    }
  },
  mounted () {

  },
  methods: {
    closePopup () {
      this.$emit('update:showAdress', false)
    },
    clickAddress (level) {
      this.level = level
    },
    selectAddresss (item, index) {
      if (this.level == 1) {
        this.level = 2
        this.activeIndex1 = item.id
        if (item.name != this.province) {
          this.province = item.name
          this.city = ''
          this.county = ''
          this.list2 = []
          this.list3 = []
          this.activeIndex2 = null
          this.activeIndex3 = null
          if (this.list2.length == 0) {
            this.getData()
          }
        }
      } else if (this.level == 2) {
        this.level = 3
        this.activeIndex2 = item.id
        if (item.name != this.city) {
          this.city = item.name
          this.county = ''
          this.list3 = []
          this.activeIndex3 = null
          if (this.list3.length == 0) {
            this.getData()
          }
        }
      } else if (this.level == 3) {
        this.activeIndex3 = item.id
        this.county = item.name
        this.$emit('getAddress', [{ id: this.activeIndex1, name: this.province }, { id: this.activeIndex2, name: this.city }, { id: this.activeIndex3, name: this.county }])
      }
    },
    getData () {
      let params = {
        id: this.level == 1 ? '1' : this.level == 2 ? this.activeIndex1 : this.activeIndex2
      }
      areaTree(params).then(res => {
        if (res.code == 0) {
          if (this.level == 1) {
            this.list1 = res.data.list
            this.list1.forEach((row) => {
              if (this.province == row.name) {
                this.activeIndex1 = row.id
                this.seletAddress[0] = this.activeIndex1
              }
            })
          } else if (this.level == 2) {
            this.list2 = res.data.list
            this.list2.forEach((row) => {
              if (this.city == row.name) {
                this.activeIndex2 = row.id
                this.seletAddress[1] = this.activeIndex1
              }
            })
          } else if (this.level == 3) {
            this.list3 = res.data.list
            this.list3.forEach((row) => {
              if (this.county == row.name) {
                this.activeIndex3 = row.id
                this.seletAddress[2] = this.activeIndex1
              }
            })
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },

    scrollCss (sty) {
      this.$nextTick(() => {
        let list = document.querySelector(sty)
        list.addEventListener('touchmove', e => e.stopPropagation(), false)
      })
    },
  }
}
</script>

<style scoped>
.address-title {
  font-size: 15px;
  color: #333333;
}

.address-selet {
  margin-top: 20px;
  margin-bottom: 19px;
}

.address-box {
  position: absolute;
  top: 88px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 22px;
  height: calc(100% - 88px);
  overflow-y: auto;
}

.address-item {
  margin-bottom: 20px;
  color: #333333;
}

.address-icon-selet {
  width: 15px;
  height: 10px;
  margin-right: 11px;
}

.address-icon-selet img {
  width: 100%;
  height: 100%;
}

.margin-right22 {
  margin-right: 22px;
  display: inline-block;
  word-break: keep-all;
  color: #333333;
  font-size: 14px;
}

.text-size {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/addresTree/index.vue